import VColumnStudent from './index.vue';

export default {
  install: (Vue) => Vue.component('VColumnStudent', VColumnStudent),
};
